<template>
  <div class="home">
    <!-- 面包屑区域 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片区域 -->
    <el-card v-loading="loading">

    </el-card>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  data() {
    return {
      loading: true
    }
  },
  created() {
    this.init();
  },
  methods: {
    async init() {

    }
  },
}
</script>
